import { useContextState } from "../../../../../../../hooks/theme"



export const useStyles = () => {
    const { colors: color } = useContextState()

    return {
        input: {
            width: "100%",
            padding: "10px",
            fontSize: "16px",
        },
        mapContainer: {
            //paddingBottom: '30px',
            padding: '24px',
            marginBottom: '24px',
            border: `1px solid ${color.color13}`,
            borderRadius: '8px',
            '& .MuiFormControlLabel-label': {
                color: color.color13,
            },
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
            width:'48%',
            height:'100%'
        },
        container:{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
        },
        title: {
            fontWeight: 'bold'
        },
        direction:{
            borderRadius: '4px',
            border: `1px solid ${color.color32}`,
            padding: '16.5px 14px'
        }
    }
}